import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../../constants/actionTypes';
import { MOBILE_WINDOW_BREAKPOINT } from '../../../constants/constants';
import { Routes } from '../../../constants/routes';
import { NavigateToRouteWithDashboardParams } from '../../../helpers/routing';
import { actions as companyDashboardActions } from '../../../actions/companyDashboardActions';
import StatusLegend from '../../Common/StatusLegend/StatusLegend';
import Notification from '../../Common/Notification';
import LocationSummaryGraph from './LocationSummaryGraph';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Button from '../../Common/Button';
import { TruncateText } from '../../../helpers/strings';

export class LocationSummary extends Component {
	constructor(props, context) {
		super(props, context);

		this._isMounted = false;

		this.state = {
			isLoading: true,
			pageSize: 20,
			pageNumber: 1,
			locationTaskCards: [],
			showMore: false,
			settings: this.props.settings || {},
		};
	}

	componentDidMount = async () => {
		this._isMounted = true;
		await this.loadSummary(false);
	};

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentDidUpdate = async (prevProps) => {
		if (this.props.settings && this.props.settings !== prevProps.settings) {
			await this.loadSummary(true);
		}
	};

	isMobile = () => {
		return this.props.windowWidth < MOBILE_WINDOW_BREAKPOINT;
	};

	loadSummary = async (isNewFilters) => {
		if (this._isMounted) this.setState({ isLoading: true });
		try {
			const response = await this.props.companyDashboardActions.loadLocationSummary(
				this.props.settings,
				this.state.pageSize,
				this.state.pageNumber
			);
			if (this._isMounted && response.type === types.LOAD_COMPANY_DASHBOARD_LOCSUMMARY_SUCCESS) {
				const showMore = response.payload.totalCount < this.state.pageSize ? false : true;

				if (response.payload.results) {
					this.setState({
						locationTaskCards:
							isNewFilters === true ? response.payload.results : this.state.locationTaskCards.concat(response.payload.results),
						showMore,
					});
				}
			} else if (this._isMounted && response.type === types.LOAD_COMPANY_DASHBOARD_LOCSUMMARY_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			if (this._isMounted) Notification('error', 'Error', error);
		} finally {
			if (this._isMounted) this.setState({ isLoading: false });
		}
	};

	onClick_LocationTasks = (urlParams) => {
		const { departmentIds, disciplineIds, isMilestonesOnly, projectIds, locationIds } = this.props.settings;

		const combinedParams = {
			...urlParams,
			disciplineId: disciplineIds,
			departmentId: departmentIds,
			projectId: projectIds,
			locationId: locationIds,
			...(isMilestonesOnly && { isMilestone: [true] }),
		};

		NavigateToRouteWithDashboardParams(Routes.Tasks, combinedParams, false);
	};

	onTitleClick = (urlParams) => {
		const { departmentIds, disciplineIds } = this.props.settings;

		const combinedParams = {
			...urlParams,
			disciplineId: disciplineIds,
			departmentId: departmentIds,
		};

		NavigateToRouteWithDashboardParams(Routes.DashboardLocation, combinedParams, false);
	};

	getBarGraphWidth = () => {
		return this.isMobile() ? 310 : 1330;
	};

	onShowMore = () => {
		this.setState(
			{
				isLoading: true,
				pageNumber: this.state.pageNumber + 1,
			},
			this.loadSummary
		);
	};

	render() {
		return (
			<Fragment>
				<div className='row'>
					<div className='col-12'>
						<div className='dashboard-widget-title'>Location+Team Summary</div>
						<div className='dashboard-widget-subtitle'>How each team is pacing with their tasks</div>
						<div className='d-inline-flex float-end'>
							<StatusLegend />
						</div>
					</div>
				</div>
				<LoadingIndicator isLoading={this.state.isLoading}>
					<Fragment>
						{!this.state.isLoading && (
							<Fragment>
								{this.state.locationTaskCards.length > 0 ? (
									<div className='row mt-3'>
										{this.state.locationTaskCards.map((card, i) => (
											<div className='col-lg-3 col-md-4 col-sm-6 mb-3' key={i}>
												<LocationSummaryGraph
													locationName={TruncateText(card.graph.title, 40)}
													locationKey={card.graph.locationKey}
													managementCompany={card.managementCompany}
													openingDate={card.openingDate}
													data={card.graph.data}
													totalUrlParams={card.graph.totalUrlParams}
													onClick={this.onClick_LocationTasks}
													onTitleClick={this.onTitleClick}
													upcomingTasksDueIds={card.upcomingTasksDueIds}
												/>
											</div>
										))}
									</div>
								) : (
									<div>No Locations found</div>
								)}
								{this.state.showMore && (
									<div className='d-flex justify-content-center mt-3'>
										<Button
											type='button'
											text='Show More'
											bootstrapClass='btn btn-link'
											name='showMore'
											onClick={this.onShowMore}
										/>
									</div>
								)}
							</Fragment>
						)}
					</Fragment>
				</LoadingIndicator>
			</Fragment>
		);
	}
}

LocationSummary.propTypes = {
	settings: PropTypes.object,
	windowWidth: PropTypes.number.isRequired,
	companyDashboardActions: PropTypes.object.isRequired,
	user: PropTypes.object,
};

function mapStateToProps(state) {
	return {
		windowWidth: state.window.width,
		user: state.user,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		companyDashboardActions: bindActionCreators(companyDashboardActions, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationSummary);
